import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'

const el = document.getElementById('rpa-app')

if (el) {
  createRoot(el).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
}
